module.exports = __webpack_public_path__ + "../assets/dist/img/darkroom-burn-1.a90eaf50.png";